import { client } from '@api/client';
import { URL } from '@api/urls';

import { TDefaultDTO } from '@interfaces/common/defaultDTO';
import { IItemsResponse } from '@interfaces/common/response';
import { IClusterZoomLevelDTO, OrganisationMapSettingsDTO } from '@interfaces/map/dto/mapDTO';
import { IUpdateOrganisationSettingsDTO } from '@interfaces/organisation/dto/organisationsDTO';
import { IOrganisationSetting, IOrganisationSettingsVendors } from '@interfaces/organisation/organisations';

const { organizationSettings, organizationSettingsVendors, organisationMapSettings } = URL;

export const getOrganisationSettings = (
	data: TDefaultDTO,
	id?: string,
): Promise<IItemsResponse<IOrganisationSetting>> => {
	return client.get(`${organizationSettings}/${id}`, {
		params: data,
	});
};

export const getOrganisationSettingsVendors = (): Promise<Array<IOrganisationSettingsVendors>> => {
	return client.get(organizationSettingsVendors);
};

export const updateOrganisationSettings = ({
	vendorsSettings,
	organisationId,
}: IUpdateOrganisationSettingsDTO): Promise<void> => {
	return client.put(`${organizationSettings}/${organisationId}/update`, {
		vendorsSettings,
	});
};

export const getOrganisationMapSettings = (): Promise<OrganisationMapSettingsDTO> => {
	return client.get(organisationMapSettings);
};

export const updateOrganisationMapSettings = ({
	clusterZoomLevel,
	organizationId,
}: IClusterZoomLevelDTO): Promise<OrganisationMapSettingsDTO> => {
	return client.post(organisationMapSettings, {
		clusterZoomLevel,
	}, {
		params: { organizationId },
	});
};
